export default {
  'data': [
    {
      'name': 'dashboard',
      'url': '/dashboard'
    },
    {
      'name': 'campaigns',
      'url': '/campaigns'
    },
    {
      'name': 'templates',
      'url': '/templates'
    },
    {
      'name': 'imagebank',
      'url': '/imagebank'
    },
  ]
};
